export default __webpack_public_path__ + "static/media/add.1f0d04fa.svg";